import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-add-redes-sociales-social',
  templateUrl: './add-redes-sociales-social.component.html',
  styleUrls: ['./add-redes-sociales-social.component.scss']
})
export class AddRedesSocialesSocialComponent implements OnInit {

  @Input() identificador;
  @Input() url;
  @Input() tipo;
  @Input() comentario;
  @Output() deleteIdRedesSociales = new EventEmitter();
  @Input() logo;

  @Output() cambioValorArrayRedesSociales = new EventEmitter();
  constructor() { }

  ngOnInit() {

  }

  public CambiaValorInput(event){
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if (elemento == "INPUT" && tipo == "text"){
      this.cambioValorArrayRedesSociales.emit({
        'identificador': this.identificador,
        'inputType': "text",
        'key': event.target.name,
        'value': event.target.value
      });
    }
  }

  public deleteRedesSociales(identificador?){
    this.deleteIdRedesSociales.emit({
      'identificador' : this.identificador
    });
  }

}
